import React, {useState} from "react";
import styled from "styled-components";
import hero from "../assets/bg2.png";
import heroDesign from "../assets/HeroDesign.png";
import Logo1 from "../assets/logo_new-1.webp";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const [navbarState, setNavbarState] = useState(false);
  const [navbarStateName, setNavbarStateName] = useState('home');
  const html = document.querySelector("html");
  html.addEventListener("click", () => setNavbarState(false));

  const navigate = useNavigate();

  const handleNavigation = (target) => {
    setNavbarStateName('products')
    navigate(target);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setNavbarState(false)
  };
  return (
    <Section id="home">
      <div className="background">
        <img src={hero} alt="Background Image" />
      </div>
      <div className="content">
        {/* <div className="sale">
          <img src={heroDesign} alt="sale" />
          <h1>
            BIG SALE
            <span>50% OFF</span>
          </h1>
        </div> */}
        <div className="info">
          {/* <img src={Logo1} alt="sale" /> */}
          <h2>ASR Academey</h2>
          {/* <em>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam
            aspernatur itaque, eius quia voluptas numquam!
          </em> */}
          <button onClick={() => handleNavigation("products")}>Explore our Centers</button>
        </div>
      </div>
    </Section>
  );
}

const Section = styled.section`
  height: 90vh;
  width: 100vw;
  position: relative;
  .background {
    height: 100%;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      filter: brightness(60%);
    }
  }
  .content {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    .sale {
      position: relative;
      left: 10%;
      img {
        height: 70vh;
      }
      h1 {
        color: white;
        position: absolute;
        top: 25vh;
        left: 15vh;
        font-size: 4.5rem;
        span {
          display: block;
          font-size: 5vw;
        }
      }
    }
    .info {
      position: absolute;
      top: 20%;
      right: 10%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 1rem;
      h2 {
        color: #f9c74f;
        font-size: 4rem;
        letter-spacing: 0.5rem;
      }
      em {
        color: white;
        width: 60%;
        text-align: end;
        font-size: 1.1rem;
        line-height: 2rem;
        letter-spacing: 0.1rem;
      }
      button {
        padding: 1rem 2rem;
        font-size: 1.4rem;
        background-color: #fc4958;
        border: none;
        border-radius: 0.5rem;
        color: white;
        font-weight: 800;
        letter-spacing: 0.2rem;
        transition: 0.3s ease-in-out;
        cursor: pointer;
        &:hover {
          background-color: #f9c74f;
        }
      }
    }
  }
  @media screen and (min-width: 260px) and (max-width: 1080px) {
    .content {
      flex-direction: column;
      .sale {
        display: none;
      }
      .info {
        top: 25%;
        h2 {
          font-size: 1.5rem;
        }
        em {
          width: 90%;
          font-size: 1rem;
          line-height: 1rem;
        }
        button{
         padding: .5rem 1rem;
          font-size: .8rem;
        }
      }
    }
  }
`;
